<template>
    <div class="baike">
        <h2 style="margin-top: 20px;">朱越洋个人百科</h2>
        <div style="padding: 20px;line-height:40px;text-align:left;margin:0 auto;" :style="{width: screenWidth >600 ?'50%':'100%'}">朱越洋
<div style="margin-bottom: 40px;">辰鳗科技集团CEO</div>

朱越洋，男，1996年，四川成都人，现任辰鳗科技集团有限公司创始人兼首席执行官，曾就职于零氪科技、叮当快药，2020年创立辰鳗科技集团有限公司，聚焦综合能源服务领域。
<div style="margin-top: 20px;"></div>
朱越洋连续入选《2023福布斯中国30 Under 30》《2024福布斯亚洲30 Under 30》《2023胡润U30中国创业先锋》《2024胡润U35中国创业先锋》及《2024年亚太U30杰出青年领袖》榜单。
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">1、人物经历</div>
<div style="margin-bottom: 20px;"></div>
朱越洋1996年出生，四川成都人。曾就职于零氪科技、叮当快药。2020年6月，朱越洋看准能源管理领域，创立了辰鳗科技。2023年带领辰鳗科技完成真成投资领投的新一轮五千万元融资。 集团总部位于成都，在北京、南京、广州、杭州、拉萨、昆明等地设有控股公司。截止2025年6月，集团业务已覆盖181个城市，服务11.7万个工商业建筑。 
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">2、个人荣誉</div>

<div style="margin-bottom: 20px;"></div>
上榜《2023常熟昆承湖·胡润U30中国创业先锋》。<div></div>
上榜2023福布斯中国30 Under 30工业制造、企业科技&零售榜单。<div></div>
上榜2024福布斯亚洲30 Under 30企业科技领域榜单。<div></div>
上榜「2024年亚太U30杰出青年领袖」教育、科技与公益类榜单。<div></div>
上榜《2024南通紫琅湖·胡润U35中国创业先锋》。<div></div>
<div style="margin-top: 20px;"></div>


<div style="font-weight: 600;">3、个人专利</div>

<div style="margin-bottom: 20px;"></div>
朱越洋发明一种带有能耗异常告警的智能电表，2022年10月14日实用新型专利权授予，专利号：2022208710992。<div></div>
朱越洋发明一种带有防窃电功能的智能电表，2022年10月14日实用新型专利权授予，专利号：2022208913821。<div></div>
<div style="margin-top: 20px;"></div>

<div style="font-weight: 600;">4、个人活动</div>


<div style="margin-bottom: 20px;"></div>


2023年4月25日，辰鳗科技CEO朱越洋受邀参加国家电投集团举办的《资本助力创新，寻找小而美潜在独角兽企业》的产业沙龙，进行圆桌分享。<div></div>
2023年8月10日，辰鳗科技CEO朱越洋受邀参加中物智库主办、昆明市物业管理行业协会协办的“夯基聚力 行则将至”2023中国物业综合实力百强企业研究发布会，辰鳗科技CEO朱越洋带来《双碳助力物企高质量发展-智慧楼宇综合能源管控解决方案》的主题分享。<div></div>
2023年12月14日，辰鳗科技CEO朱越洋受邀参加中物智库举办的“长大以后”2023熙说物业年度演讲，进行了《辰鳗科技能源数字化管理解决方案》的主题演讲。<div></div>


</div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            screenWidth: document.body.clientWidth,

        }
    },
    mounted() {
        console.log(this.screenWidth);
    },
    methods: {
        
    }
}
</script>

<style>
    .baike{
        font-size: 16px;
        height: 100vh;
        overflow: scroll;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/aboutcsr.vue